import React from "react";
import moment from "moment";

const DateCreatedColumnFormatter = (
  cellContent,
  row
) => {
  return (
    <span>
      {row.created_at ? moment(row.created_at).format("MM/DD/YYYY") : ""}
    </span>
  )
}

export default DateCreatedColumnFormatter;
